/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Send_ButtonInputs */



/**
* | output |
* | --- |
* | "Send email" |
*
* @param {Explorer_Assignment_Email_Send_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_send_button = /** @type {((inputs?: Explorer_Assignment_Email_Send_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Send_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer l'e-mail")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail senden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправить письмо")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar correo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发送邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールを送信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल भेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar e-mail")
	return /** @type {LocalizedString} */ ("Send email")
});